<sm-spinner [loading]="loading$"></sm-spinner>
<div class="my-5">
  <sm-page-header [title]="'dac.title' | translate" [breadcrumb]="breadcrumb"></sm-page-header>

  <div class="flex flex-row gap-5">
    <!-- Form -->
    <div class="flex flex-col gap-4 w-3/4">
      <div class="content" *ngIf="isMetadataExisting | async">
        <div class="h-fit flex flex-col gap-4" *ngFor="let blocks of metadataBlocks">
          <sm-block-builder [blocks]="blocks"></sm-block-builder>
        </div>
      </div>
      <!-- Form -->
      <div class="content">
        <sm-form-builder [formObject]="formObject"></sm-form-builder>
      </div>
    </div>
    <!-- Meta Blocks -->
    <div class="flex flex-col gap-2 w-1/4 sticky top-5 h-full">
      <sm-status [status]="`dac.status.${status}`" [extra]="dacDetails?.dacDocs?.etapeProcess || ''"></sm-status>
      <div class="content">
        <p class="text-base opacity-50 text-center">{{ (dacDetails?.dacDocs?.scenarioId ?
          'dac.configuration.config_exists'
          :
          'dac.configuration.no_config' )| translate }}</p>
        <p-button styleClass="mt-2 w-full" severity="secondary"
          [routerLink]="['/dac-configure', dacDetails?.dacDocs?.dacId, dacDetails?.dacDocs?.dacVer]"
          [label]="'dac.configuration.configure_now' | translate"></p-button>
      </div>
      <div class="content h-fit flex flex-col gap-4" *ngFor="let blocks of controlBlocks">
        <sm-block-builder [blocks]="blocks"></sm-block-builder>
      </div>
    </div>
  </div>

  <sm-pdf-preview-modal [(visible)]="showPdfModal" [pdfBase64]="pdfBase64" [filename]="pdfFilename">
  </sm-pdf-preview-modal>
  <sm-dialog #dialog [dialog]="dacDialogObject"></sm-dialog>
  <sm-drawer #editDynamicDocsDrawer [drawer]="editDynamicDocsDrawerObject"></sm-drawer>
</div>